<template>
    <form class="form-horizontal" style="margin-top: 20px" v-if="veiculo && veiculo.uuid">

        <div class="form-group">
          <label for="oficina" class="col-sm-6 control-label text-danger">
            Ao habilitar a OFICINA, todos os eventos e notificações serão descartados.
          </label>
        </div>

        <div class="form-group">
            <label for="oficina" class="col-sm-2 control-label">HABILITAR OFICINA:</label>
            <div class="col-sm-3">
                <combo-true-false id="oficina" v-model="veiculo.oficina"></combo-true-false>
            </div>

            <label for="termino_oficina" class="col-sm-2 control-label">DATA DE TERMINO:</label>
            <div class="col-sm-3">
                <input type="date" :disabled="! veiculo.oficina" id="termino_oficina" v-model="veiculo.termino_oficina" class="form-control">
            </div>
        </div>

        <div class="form-group">
            <label for="texto" class="col-sm-2 control-label text-uppercase">Observação:</label>
            <div class="col-sm-10">
                <textarea style="height: 50px !important;" maxlength="140" v-model="veiculo.oficina_txt" aria-valuemax="140" class="form-control" id="texto" ></textarea>
                <small class="text-uppercase">Limite de 140 caracteres</small>
            </div>
        </div>

        <div class="form-group">
            <label for="termino_oficina" class="col-sm-2 control-label"></label>
            <div class="col-sm-3">
                <button @click.prevent="salvar" class="btn btn-block btn-success btn-xs">SALVAR OFICINA</button>
            </div>
        </div>
    </form>
</template>

<script>
import {Veiculo} from "../../class";
import ComboTrueFalse from '../../components/combos/ComboTrueFalse';

export default {
    name: "HabilitarOficina",
    props: {
        veiculo: {
            default: null
        }
    },
    components: {
        ComboTrueFalse
    },
    methods: {
        salvar () {

            if (this.veiculo.oficina && ! this.veiculo.termino_oficina) {
              return toastr.error("A DATA DE TÉRMINO é obrigatória");
            }

            swal({
                title: 'Posso Confirmar?',
                text: "Habilitar o alerta de transmissão?",
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, pode habilitar!'
            }).then(() => {
                try {
                    Veiculo.oficina(this.veiculo.uuid, this.veiculo.oficina, this.veiculo.termino_oficina, this.veiculo.oficina_txt).then(() =>
                        this.$emit('reload', this.veiculo.id_veiculo)
                    );
                } catch (err) {
                    console.error(err);
                    return toastr.error("Não Habilitado");
                }
            });
        },
    }
}
</script>

<style scoped>

</style>
